import { ArrowDown, Lightning } from "@phosphor-icons/react";
import { CLUB } from "../data/mockData";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/784dbb52-c333-452b-9dc0-e74e42a3174e/images/8b996557d2e86cfd19fbfbc0709a98546cda124cc1c1905f64075c400e30ac8e.png";

export const Hero = () => {
  const marquee = [
    "SÆSON 25/26",
    "DANMARKSSERIEN",
    "SIDST: TFC 3–1 AVARTA",
    "NÆSTE: TFC vs BRØNSHØJ · 12.04",
    "NY KLUBCHEF: DANIEL MØLGAARD",
    "20% RABAT HOS UNISPORT FOR MEDLEMMER",
    "1000+ MEDLEMMER — HJÆRTET AF KLUBBEN",
  ];

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative isolate min-h-[100svh] overflow-hidden grain"
    >
      <img
        src={HERO_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#0A0A0A]" />
      <div className="absolute inset-0 pitch-lines opacity-40" />

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl flex-col justify-between px-6 pb-10 pt-32 lg:px-10 lg:pt-40">
        <div className="max-w-5xl">
          <div
            className="mono-label mb-6 inline-flex items-center gap-3 text-brand"
            data-testid="hero-eyebrow"
          >
            <span className="h-[1px] w-10 bg-brand" />
            Sammenlagt {CLUB.founded} · B70 + TIK 90 · Taastrup, Danmark
          </div>

          <h1
            data-testid="hero-title"
            className="font-heading text-[14vw] leading-[0.85] tracking-tighter text-white sm:text-[12vw] lg:text-[9.5rem]"
          >
            TAASTRUP
            <br />
            <span className="text-brand">FC</span>
            <span className="ml-4 align-top text-white">.</span>
          </h1>

          <p
            data-testid="hero-tagline"
            className="mt-6 max-w-2xl font-body text-lg leading-relaxed text-neutral-300 sm:text-xl"
          >
            {CLUB.tagline} {CLUB.description}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#traening"
              data-testid="hero-cta-training"
              className="btn-primary"
            >
              <Lightning weight="fill" size={18} />
              Træningstider
            </a>
            <a
              href="#baneoversigt"
              data-testid="hero-cta-pitches"
              className="btn-ghost"
            >
              Baneoversigt
            </a>
          </div>
        </div>

        <div className="relative mt-16 flex items-end justify-between gap-8">
          <a
            href="#baneoversigt"
            data-testid="hero-scroll-hint"
            className="mono-label hidden items-center gap-2 text-neutral-400 hover:text-brand md:inline-flex"
          >
            <ArrowDown size={16} /> Rul ned
          </a>
          <div className="grid w-full grid-cols-2 gap-4 sm:grid-cols-4 md:max-w-2xl">
            {CLUB.stats.map((s) => (
              <div
                key={s.label}
                data-testid={`hero-stat-${s.label.toLowerCase()}`}
                className="border border-neutral-800 bg-black/50 p-4 backdrop-blur-sm"
              >
                <div className="font-heading text-3xl text-white sm:text-4xl">
                  {s.value}
                </div>
                <div className="mono-label mt-1 text-neutral-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div
        data-testid="hero-marquee"
        className="relative z-10 border-y border-neutral-800 bg-black/70 py-3"
      >
        <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
          {[...marquee, ...marquee].map((item, i) => (
            <span
              key={i}
              className="mono-label flex items-center gap-10 text-neutral-300"
            >
              <span className="inline-block h-1 w-1 bg-brand" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
